export const URL_SLUG_ID_SEPARATOR = "-";

export const combineSlugId = (
  slug: string,
  id: string | number,
  separator: string = URL_SLUG_ID_SEPARATOR
) => {
  return slug + separator + id;
};
